import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const KompletteraUppgifterTest = lazy(() => import("@/pages/KompletteraUppgifterTest"));

export const Route = createFileRoute("/komplettera-uppgifter-test")({
  ssr: false,
  validateSearch: (search: Record<string, unknown>) => ({
    reasons: typeof search["reasons"] === "string" ? search["reasons"] : "",
  }),
  head: () => ({
    meta: [
      { title: "Testvy: komplettera din beställning | Elmarknad.se" },
      {
        name: "description",
        content:
          "Testvy av kompletteringsformuläret för returnerade bytesförfrågningar – kräver ingen referens och sparar inget.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { name: "googlebot", content: "noindex, nofollow" },
      { property: "og:title", content: "Testvy: komplettera din beställning | Elmarknad.se" },
      {
        property: "og:description",
        content: "Testvy av kompletteringsformuläret hos Elmarknad.se.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <KompletteraUppgifterTest />,
});
